import { ReplinesClient } from './ReplinesClient';

const _default_1: ReplinesClient = new ReplinesClient();

export default _default_1;
